// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./font/Nunito-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    margin: 0px;
    padding: 0px;
    background-color: white;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    overflow: hidden;
}

@font-face {
    font-family: "Nunito";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

#feedback{
    position: fixed;
    display: none;
    z-index:50000;
    color:aliceblue;
    background-color: rgb(0, 0, 0);
}

#loadingImage{
    position: fixed;
    width: 237px;
    height: 46px;

    font-family: 'Gotham-Book';
    color: #333333;
    font-size: 20pt;
    text-align: center;
    
    top:0;
    bottom:0;
    left: 0;
    right: 0;
    margin:auto;
    z-index: 11000;

    image-rendering: smooth ;
    pointer-events: none;
}

#loadingBack{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index:10000;
    background-color: white;
    pointer-events: none;
    /* display: none; */
}

#backgroundDiv{
    position: absolute;
    width: 100%;
    background-color: black;
    max-width: 900px;
    max-height: 900px;
    /* border: 1px solid red; */
}

#background{
    /* position: absolute; */
    width: 100%;
    /* max-width: 300px; */
    /* opacity: 0; */
}

.pushDown{
    display: none;
}

#pauseBut{
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9000;
    background-color: green;
    border-radius: 15px;
    color: white;
    padding: 2px;
    padding-left: 12px;
    padding-right: 12px;
    font-family: Nunito;
    opacity: 1;
    pointer-events: none;
}

#dragMe{
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 11000;
    background-color: #333333;
    border-radius: 15px;
    color: white;
    padding: 2px;
    padding-left: 12px;
    padding-right: 12px;
    font-family: Nunito;
    opacity: 0;
    pointer-events: none;
}

canvas {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    touch-action: none; /* ✅ prevent scrolling on touch drag */
  }

#myTextLabel{
    position: absolute;
    top: 100px;
    /* left: 450px; */
    max-width: 900px;
    width: 100%;
    text-align: center;
    /* transform: translateX(-50%); */
    z-index: 11000;
    color: white;
    font-size: 32pt;
    font-family: Nunito;
    opacity: 0;
    /* border: 1px solid red; */
}

#mixer{
    position: absolute;
    z-index: 11000;
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,4CAAqC;AACzC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;;IAEZ,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,kBAAkB;;IAElB,KAAK;IACL,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,WAAW;IACX,cAAc;;IAEd,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB,EAAE,sCAAsC;EAC5D;;AAEF;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB","sourcesContent":["body{\r\n    margin: 0px;\r\n    padding: 0px;\r\n    background-color: white;\r\n    user-select: none;\r\n    -webkit-user-select: none;\r\n    -khtml-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    overflow: hidden;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"Nunito\";\r\n    src: url(\"./font/Nunito-Regular.ttf\");\r\n}\r\n\r\n#feedback{\r\n    position: fixed;\r\n    display: none;\r\n    z-index:50000;\r\n    color:aliceblue;\r\n    background-color: rgb(0, 0, 0);\r\n}\r\n\r\n#loadingImage{\r\n    position: fixed;\r\n    width: 237px;\r\n    height: 46px;\r\n\r\n    font-family: 'Gotham-Book';\r\n    color: #333333;\r\n    font-size: 20pt;\r\n    text-align: center;\r\n    \r\n    top:0;\r\n    bottom:0;\r\n    left: 0;\r\n    right: 0;\r\n    margin:auto;\r\n    z-index: 11000;\r\n\r\n    image-rendering: smooth ;\r\n    pointer-events: none;\r\n}\r\n\r\n#loadingBack{\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index:10000;\r\n    background-color: white;\r\n    pointer-events: none;\r\n    /* display: none; */\r\n}\r\n\r\n#backgroundDiv{\r\n    position: absolute;\r\n    width: 100%;\r\n    background-color: black;\r\n    max-width: 900px;\r\n    max-height: 900px;\r\n    /* border: 1px solid red; */\r\n}\r\n\r\n#background{\r\n    /* position: absolute; */\r\n    width: 100%;\r\n    /* max-width: 300px; */\r\n    /* opacity: 0; */\r\n}\r\n\r\n.pushDown{\r\n    display: none;\r\n}\r\n\r\n#pauseBut{\r\n    position: absolute;\r\n    bottom: 30px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    z-index: 9000;\r\n    background-color: green;\r\n    border-radius: 15px;\r\n    color: white;\r\n    padding: 2px;\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n    font-family: Nunito;\r\n    opacity: 1;\r\n    pointer-events: none;\r\n}\r\n\r\n#dragMe{\r\n    position: absolute;\r\n    bottom: 70px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    z-index: 11000;\r\n    background-color: #333333;\r\n    border-radius: 15px;\r\n    color: white;\r\n    padding: 2px;\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n    font-family: Nunito;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n}\r\n\r\ncanvas {\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    user-select: none;\r\n    touch-action: none; /* ✅ prevent scrolling on touch drag */\r\n  }\r\n\r\n#myTextLabel{\r\n    position: absolute;\r\n    top: 100px;\r\n    /* left: 450px; */\r\n    max-width: 900px;\r\n    width: 100%;\r\n    text-align: center;\r\n    /* transform: translateX(-50%); */\r\n    z-index: 11000;\r\n    color: white;\r\n    font-size: 32pt;\r\n    font-family: Nunito;\r\n    opacity: 0;\r\n    /* border: 1px solid red; */\r\n}\r\n\r\n#mixer{\r\n    position: absolute;\r\n    z-index: 11000;\r\n    display: none;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
